import { useMutation } from '@tanstack/react-query';

import { ExpensesApi } from '../expenses.api';

export const useGetCalculationsTotalExpanses = () => {
  return useMutation({
    mutationFn: ExpensesApi.getExpensesCalculationsByCategory,
  });
};
